export const DEFAULT_LOCALE = "en-en";

export const GA_KEY = process.env.REACT_APP_GA_KEY || "";
export const ORGANISATION = process.env.REACT_APP_ORGANISATION || "";

export const NL_TRANSLATION_FILE =
  process.env.REACT_APP_NL_TRANSLATIONS ?? "nl.json";
